export default __webpack_public_path__ + "static/Resume-Ron-Pruitt-a8e3396678bed3d418589f7763a9c189.pdf";